module.exports = __webpack_public_path__ + "img/appAsset--organization-ax.39306629.svg";